export default "__VITE_ASSET__7d8d28cf__"